import React from "react";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import { Link } from "react-router-dom";

const ImageLink = ({ to, src, alt, text }) => (
  <div className="folder-item">
    <Link to={to}>
      <img src={src} className="img-fluid hover-effect" alt={alt} />
    </Link>
    <p className="text-strong">{text}</p>
  </div>
);

const PlanesdeTrabajo = () => {
  return (
    <>
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Avisos de Privacidad" },
        ]}
      />

      <TitlePages title="Transparencia" subTitle="Avisos de Privacidad" />

      <div className="w-100 Grid__folder margin-bottom-2">
        <ImageLink
          to="/AvisosPriv2020"
          src="https://itetlax.org.mx/assets/img/icons/33.png"
          alt="Plan de Trabajo 2020"
        />
        <ImageLink
          to="/AvisosPriv2021"
          src="https://itetlax.org.mx/assets/img/icons/34.png"
          alt="Plan de Trabajo 2021"
        />
        <ImageLink
          to="/AvisosPriv2022"
          src="https://itetlax.org.mx/assets/img/icons/35.png"
          alt="Plan de Trabajo 2022"
        />
        <ImageLink
          to="/AvisosPriv2023"
          src="https://itetlax.org.mx/assets/img/icons/36.png"
          alt="Plan de Trabajo 2023"
        />
        <ImageLink
          to="/AvisosPriv2024"
          src="https://itetlax.org.mx/assets/img/icons/2024.png"
          alt="Plan de Trabajo 2024"
        />

        <ImageLink
          to="/AvisosPriv2025"
          src="https://itetlax.org.mx/assets/img/icons/2025.png"
          alt="Plan de Trabajo 2025"
        />

        <ImageLink
          to="/AvisosPriv2026"
          src="https://itetlax.org.mx/assets/img/icons/2026.png"
          alt="Plan de Trabajo 2026"
        />

      </div>
    </>
  );
};

export default PlanesdeTrabajo;
